import styled from "vue-styled-components";

export default styled.div`
  & .menu-item {
    display: flex;
    flex-direction: column;
    padding-right: 0;

    & .menu-content {
      display: flex;
      cursor: pointer;
      padding-left: 15px;
      height: 50px;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      border-bottom: 1px solid #efefef;
      padding-right: 15px;

      &:hover {
        background-color: #efefef;
      }
    }

    & .icon {
      margin-right: 5px;
    }

    & .menu-options {
      margin-left: auto;

      & .check {
        margin-left: 10px;
      }
    }
  }`